module.exports = {
      id: "video-play-btn-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#video-play-btn",
      toString: function () {
        return this.url;
      }
    }